import { render, staticRenderFns } from "./LicensePlanCard.vue?vue&type=template&id=5c110ca8&scoped=true"
import script from "./LicensePlanCard.vue?vue&type=script&lang=js"
export * from "./LicensePlanCard.vue?vue&type=script&lang=js"
import style0 from "./LicensePlanCard.vue?vue&type=style&index=0&id=5c110ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c110ca8",
  null
  
)

export default component.exports